import { useEffect, useState } from "react";
import {
  PollingEventStateSync,
  PollingOptimisticEventStateSync,
} from "../alias";
import { useInterval, useRender } from "../jsx/hook";

export const useStateManager = <State, Event>(
  stateManager:
    | PollingOptimisticEventStateSync<State, Event>
    | PollingEventStateSync<State, Event>,
  onBeforeChange?: (state: State, event: Event) => void,
  allowedToRender = true
) => {
  const render = useRender();
  const [status, setStatus] =
    useState<ReturnType<typeof stateManager.getSyncStatus>>("synced");
  useEffect(() => {
    const { eventStateManager } = stateManager;
    eventStateManager.onBeforeChange = (state, event) => {
      onBeforeChange?.(state, event);
    };
    eventStateManager.onChange = () => {
      allowedToRender && render();
    };
    return () => {
      stateManager.eventStateManager.onBeforeChange = undefined;
      stateManager.eventStateManager.onChange = undefined;
    };
  }, [render, allowedToRender]);
  useEffect(() => {
    stateManager.start();
  }, []);
  useInterval(
    () => {
      const newStatus = stateManager.getSyncStatus();
      if (newStatus !== status) {
        setStatus(newStatus);
      }
    },
    100,
    [status, stateManager, setStatus]
  );

  return { status };
};
